import React, { useEffect } from 'react';
import {
  Box,
  GDSStyleObject,
  HeadingText,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { HtmlToReact } from '@leagueplatform/web-common';
import { useStaticAsset } from '@leagueplatform/asset-config';
import useEasyPlanStore from '../../../store/easy-plan-store';
import { EASYPLAN_ASSET_KEYS } from '../../../types/easy-plan-asset.types';
import { EasyPlanContainerComponent } from '../easyPlan-container.component';
import { CostAccordionComponent } from './cost-accordion.component';

export function CostLevelComponent(props: any) {
  const { errorHandling } = props;
  const easyPlanResponse = useEasyPlanStore(
    (state: any) => state.easyPlanHomeInfo,
  );

  useEffect(() => {
    errorHandling(true);
  }, [errorHandling]);

  return (
    <EasyPlanContainerComponent
      image={useStaticAsset(EASYPLAN_ASSET_KEYS.TOP_IMAGE_COST_ICON) as string}
      title={easyPlanResponse?.easyPlanHome?.cost?.title}
      description={easyPlanResponse?.easyPlanHome?.cost?.description}
      dataTestId="costLevelComponent"
    >
      <Box
        css={
          {
            width: '327px',
            textAlign: 'center',
            borderRadius: '9px',
            border: '1px solid #E0E2E4',
            background: '$onSurfacePrimary',
            padding: '$one',
          } as GDSStyleObject
        }
      >
        <HeadingText
          size="md"
          level="4"
          css={
            {
              fontSize: '$headingThree',
              textAlign: 'left',
              padding: '$half $none',
              fontWeight: '$overline !important',
              marginLeft: '0px',
              lineHeight: '$buttonOne !important',
              letterSpacing: '$headingFour',
            } as GDSStyleObject
          }
        >
          {easyPlanResponse?.easyPlanHome?.cost?.breakdown?.title}
        </HeadingText>
        <CostAccordionComponent
          costContent={easyPlanResponse?.easyPlanHome?.cost}
        />
      </Box>
      <Box css={{ width: '327px' }}>
        <ParagraphText
          css={{
            marginTop: '$one',
            marginBottom: '$one',
            fontSize: '$bodyOne',
            lineHeight: '$subtitleOne',
            textAlign: 'center',
          }}
          emphasis="subtle"
        >
          <HtmlToReact
            htmlString={easyPlanResponse?.easyPlanHome?.cost?.footerDescription}
          />
        </ParagraphText>
      </Box>
      <Box css={{ width: '327px' }}>
        <ParagraphText
          css={{
            fontSize: '$label',
            paddingBottom: '$twoAndHalf',
            lineHeight: '$label',
            textAlign: 'center',
            fontWeight: '$bodyOneSecondary',
            '@mobile': {
              paddingBottom: '110px',
            },
          }}
          emphasis="subtle"
        >
          <HtmlToReact
            htmlString={easyPlanResponse?.easyPlanHome?.cost?.footerSubtext}
          />
        </ParagraphText>
      </Box>
    </EasyPlanContainerComponent>
  );
}
